import { createContext, useState, useEffect } from "react";
import "./Loader.css";
export const LoaderContext = createContext();
const Loader = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 50000);
  }, []);
  return (
    <LoaderContext.Provider value={{ loading }}>
      {loading ? (
        <div
          className="p-component p-fluid background-div"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f0f0f0",
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              fontFamily: "Venera-700 !important",
              fontWeight: "bold",
            }}
            className="heartbeat"
          >
            <img
              src="/img/skeyeform_initial_logo.svg"
              alt="Logo"
              style={{ marginBottom: "1rem", width: "300px", height: "300px" }}
            />
            <br />
            <span
              style={{
                fontSize: "1.5rem",
                fontFamily: "Venera-700",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  color: "#d97a07",
                }}
              >
                Skeye
              </span>{" "}
              <span style={{ color: "#0d2e4d" }}>Form™</span>
            </span>
            <br />
            <br />
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </LoaderContext.Provider>
  );
};

export default Loader;
